import { ref } from 'vue'
import { defineStore } from 'pinia'

export const ModalType = Object.freeze({
  INFO: 'info',
  SUCCESS: 'success',
  CONFIRM: 'confirm',
  WARNING: 'warning',
  ERROR: 'error',
})

export const Mode = Object.freeze({
  DELETE_APP: 'DELETE_APP',
  DELETE_COMPETITOR: 'DELETE_COMPETITOR',
  DELETE_KEYWORDS_BY_COUNTRY: 'DELETE_KEYWORDS_BY_COUNTRY',
  LIMIT_REACHED_COMPETITOR: 'LIMIT_REACHED_COMPETITOR',
  LIMIT_REACHED_KEYWORD_BY_COUNTRY: 'LIMIT_REACHED_KEYWORD_BY_COUNTRY',
  APP_COUNTRY_DOES_NOT_MATCH: 'APP_COUNTRY_DOES_NOT_MATCH',
  MA_NEW_RELEASE: 'MA_NEW_RELEASE',
  PLAN_DOWNGRADE: 'PLAN_DOWNGRADE',
})

export const useDashboardStore = defineStore('dashboard', () => {
  /**
   * while one modal is visible, other modal visible requests are ignored.
   */
  const isVisible = ref(false)

  /**
   * the data that the modal to be opened will use is stored in this variable.
   */
  const state = ref(null)

  const mode = ref(null)
  const confirmLoading = ref(false)
  const modalType = ref(ModalType.INFO)

  const open = (data = null) => {
    state.value = data
    isVisible.value = true
  }

  const openDeleteAppModal = (app) => {
    if (isVisible.value)
      return

    modalType.value = ModalType.ERROR
    mode.value = Mode.DELETE_APP
    open(app)
  }

  const openDeleteCompetitorModal = (data) => {
    if (isVisible.value)
      return

    modalType.value = ModalType.ERROR
    mode.value = Mode.DELETE_COMPETITOR
    open(data)
  }

  const openDeleteKeywordsByCountryModal = (data) => {
    if (isVisible.value)
      return

    modalType.value = ModalType.ERROR
    mode.value = Mode.DELETE_KEYWORDS_BY_COUNTRY
    open(data)
  }

  const openAppCountryError = () => {
    if (isVisible.value)
      return

    modalType.value = ModalType.WARNING
    mode.value = Mode.APP_COUNTRY_DOES_NOT_MATCH
    open()
  }

  const openNewReleaseWarning = () => {
    if (isVisible.value)
      return

    modalType.value = ModalType.WARNING
    mode.value = Mode.MA_NEW_RELEASE
    open()
  }

  const openCountryBasedKeywordLimitReachedModal = () => {
    if (isVisible.value)
      return
    modalType.value = ModalType.WARNING
    mode.value = Mode.LIMIT_REACHED_KEYWORD_BY_COUNTRY
    open()
  }

  const openPlanDowngradeModal = (data) => {
    if (isVisible.value)
      return

    modalType.value = ModalType.WARNING
    mode.value = Mode.PLAN_DOWNGRADE
    open(data)
  }

  const $reset = () => {
    mode.value = null
    isVisible.value = false
    confirmLoading.value = false
    modalType.value = ModalType.INFO
    state.value = null
  }

  return {
    mode,
    isVisible,
    confirmLoading,
    modalType,
    state,
    openDeleteAppModal,
    openDeleteCompetitorModal,
    openDeleteKeywordsByCountryModal,
    openAppCountryError,
    openNewReleaseWarning,
    openCountryBasedKeywordLimitReachedModal,
    openPlanDowngradeModal,
    $reset,
  }
})
